import classNames from 'classnames';
import { CustomButton } from '../../../../features/customButton';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function Close({ className, modifier, btnModifier, img, ...extraProps }) {
  return (
    <CustomButton
      icon={img ?? 'buttons/cross'}
      className={classNames(
        'universal-modal__close',
        'back__button',
        'button_back',
        'button_icon',
        'button_transparent',
        className,
        ...combineModifiers('universal-modal__close', modifier),
        ...combineModifiers('button', btnModifier),
      )}
      {...extraProps}
    />
  );
}
